import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useCallback } from 'react';
import { setCreateGameType } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { ALL_CREATE_ROOM_TYPE_PROPERTIES } from '../../../types/sharedTypes';
import { CreateGameMenuItemContents } from './createGameMenuItemContents';
function isRoomTypeDisabled(variantId, roomType, isPowerPlayer) {
    const { isPowerPlayerOnly, validator } = ALL_CREATE_ROOM_TYPE_PROPERTIES[roomType];
    if (isPowerPlayerOnly && !isPowerPlayer) {
        return true;
    }
    if (!validator) {
        return false;
    }
    return !validator({ variantId });
}
function getSvgIcon(roomType, isPowerPlayer) {
    const { isPowerPlayerOnly, svgIconComponent: defaultSvgIconComponent } = ALL_CREATE_ROOM_TYPE_PROPERTIES[roomType];
    if (isPowerPlayerOnly && !isPowerPlayer) {
        return LockRoundedIcon;
    }
    return defaultSvgIconComponent;
}
export const RoomTypeControl = () => {
    const dispatch = useAppDispatch();
    const roomType = useAppSelector((state) => state.createGame.roomType);
    const variantId = useAppSelector((state) => state.createGame.variantId);
    const isPowerPlayer = useAppSelector((state) => !!state.selfData.isPowerPlayer);
    const onChangeRoomType = useCallback((event) => {
        dispatch(setCreateGameType(event.target.value));
    }, [dispatch]);
    return (_jsxs(FormControl, { variant: 'outlined', children: [_jsx(InputLabel, { children: "Type" }), _jsx(Select, { "data-testid": 'create-game-type-select', value: roomType, label: 'Type', onChange: onChangeRoomType, children: Object.entries(ALL_CREATE_ROOM_TYPE_PROPERTIES).map(([currRoomType, { name }], i) => {
                    const disabled = isRoomTypeDisabled(variantId, currRoomType, isPowerPlayer);
                    const SvgIconComponent = getSvgIcon(currRoomType, isPowerPlayer);
                    return (_jsx(MenuItem, { value: currRoomType, disabled: disabled, children: _jsx(CreateGameMenuItemContents, { icon: SvgIconComponent, label: name }) }, i));
                }) })] }));
};
